// 第一页面
export const getMonthFrom = ({ commit }, payload) => {
    commit('getMonthFrom', payload);
};
export const getMonthTo = ({ commit }, payload) => {
    commit('getMonthTo', payload);
};
export const getBrand = ({ commit }, payload) => {
    commit('getBrand', payload);
};
export const getCateGory1 = ({ commit }, payload) => {
    commit('getCateGory1', payload);
};
export const getCateGory2 = ({ commit }, payload) => {
    commit('getCateGory2', payload);
};
export const getPlatForm = ({ commit }, payload) => {
    commit('getPlatForm', payload);
};
export const getFlag = ({ commit }, payload) => {
    commit('getFlag', payload);
};
//第二页面
export const getComMonthFrom = ({ commit }, payload) => {
    commit('getComMonthFrom', payload);
}; 
export const getComFlag = ({ commit }, payload) => {
    commit('getComFlag', payload);
};
export const getComMonthTo= ({ commit }, payload) => {
    commit('getComMonthTo', payload);
}; 
export const getComBrand = ({ commit }, payload) => {
    commit('getComBrand', payload);
}; 
export const getComCateGory2 = ({ commit }, payload) => {
    commit('getComCateGory2', payload);
};
export const getComCateGory3 = ({ commit }, payload) => {
    commit('getComCateGory3', payload);
};
export const getComCateGory1 = ({ commit }, payload) => {
    commit('getComCateGory1', payload);
};
//第三页面
export const getCouMonthFrom = ({ commit }, payload) => {
    commit('getCouMonthFrom', payload);
};
export const getCouMonthTo = ({ commit }, payload) => {
    commit('getCouMonthTo', payload);
};
export const getCouBrand = ({ commit }, payload) => {
    commit('getCouBrand', payload);
};
export const getCouCateGory1 = ({ commit }, payload) => {
    commit('getCouCateGory1', payload);
};
export const getCouCateGory2 = ({ commit }, payload) => {
    commit('getCouCateGory2', payload);
};


// WEBPACK FOOTER //
// ./src/store/actions.js